import produce from "immer";
import { DictionaryAction, LOAD_DICTIONARY } from "./dictionary.actions";
import DictionaryRootState from "components/Dictionary/redux/dictionary-redux-state.interface";

const initialState: DictionaryRootState = {
    translations: {}
};

export default (dictionaryState = initialState, action: DictionaryAction): DictionaryRootState => produce(dictionaryState, draft => {
    switch (action.type) {
        case LOAD_DICTIONARY: {
            draft.translations = action.translations;
            break;
        }
    }
});